import React, { useMemo, useState, useEffect } from "react";
import { useGlobalContext } from "../Config";
import { InputText } from "primereact/inputtext";
import { Dropdown } from "primereact/dropdown";
import { Button } from "primereact/button";
import { TabView, TabPanel } from "primereact/tabview";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { ProgressSpinner } from "primereact/progressspinner";
import { Dialog } from "primereact/dialog";
import { InputTextarea } from "primereact/inputtextarea";
import { InputNumber } from "primereact/inputnumber";
import { Tag } from "primereact/tag";

const RevisionPeriodo = () => {
  const { baseUrl } = useGlobalContext();
  const { urlDocumentos } = useGlobalContext();

  const [isLoading, setIsLoading] = useState(false);

  const [empresaId, setEmpresaId] = useState(null);
  const [mes, setMes] = useState(null);
  const [anio, setAnio] = useState(null);
  const [tipoId, setTipoId] = useState(null);

  const [estadoResp, setEstadoResp] = useState(null);
  const [activeEstadoTab, setActiveEstadoTab] = useState(0);

  const [detalleItems, setDetalleItems] = useState([]);
  const [boletasInfo, setBoletasInfo] = useState([]);
  const [lastQuery, setLastQuery] = useState(null);

  const [selectedItems, setSelectedItems] = useState([]);
  const [itemChanges, setItemChanges] = useState({});
  const [correctionDialogVisible, setCorrectionDialogVisible] = useState(false);
  const [correctionRow, setCorrectionRow] = useState(null);
  const [correctionDraft, setCorrectionDraft] = useState({
    lecturaMesAnterior: null,
    lecturaMesActual: null,
    consumoMesAnterior: null,
    consumoMesActual: null,
    saldoAnterior: null,
    valorUnitario: null,
    motivoCorreccion: "",
  });

  const [activeMainTab, setActiveMainTab] = useState(0);
  const [fEstado, setFEstado] = useState({
    remarcador: "",
    qr: "",
    servicio: null,
    estadoLectura: null,
    medidorPadre: "",
  });

  const [fDetalle, setFDetalle] = useState({
    domicilio: "",
    cliente: "",
    rut: "",
    servicio: null,
    remarcador: "",
    estadoBoleta: null,
  });
  const [tipos, setTipos] = useState([]);

  const empresasOptions = [
    { label: "ALTAMIRA", value: 1 },
    { label: "LA SIEMBRA", value: 2 },
  ];

  const mesesOptions = [
    { label: "Enero", value: 1 },
    { label: "Febrero", value: 2 },
    { label: "Marzo", value: 3 },
    { label: "Abril", value: 4 },
    { label: "Mayo", value: 5 },
    { label: "Junio", value: 6 },
    { label: "Julio", value: 7 },
    { label: "Agosto", value: 8 },
    { label: "Septiembre", value: 9 },
    { label: "Octubre", value: 10 },
    { label: "Noviembre", value: 11 },
    { label: "Diciembre", value: 12 },
  ];

  const aniosOptions = [2024, 2025, 2026].map((y) => ({
    label: String(y),
    value: y,
  }));

  const buildPeriodo = () => {
    if (!anio || !mes) return "";
    return `${anio}-${String(mes).padStart(2, "0")}`;
  };

  const periodoLabel = useMemo(() => buildPeriodo() || "—", [anio, mes]);

  const fetchJson = async (url, options = {}) => {
    const res = await fetch(url, {
      credentials: "include",
      redirect: "follow",
      ...options,
      headers: {
        "Content-Type": "application/json",
        ...(options.headers || {}),
      },
    });

    const data = await res.json().catch(() => ({}));
    if (!res.ok || data?.respuesta === false) {
      const msg = data?.mensaje || `Error HTTP ${res.status}`;
      throw new Error(msg);
    }
    return data;
  };

  const validar = () => {
    if (!empresaId) {
      alert("Debe seleccionar empresa.");
      return false;
    }
    if (!anio || !mes) {
      alert("Debe seleccionar mes y año.");
      return false;
    }
    return true;
  };

  useEffect(() => {
    (async () => {
      try {
        const data = await fetchJson(`${baseUrl}tipo/buscar`, {
          method: "GET",
        });
        setTipos(Array.isArray(data?.tipos) ? data.tipos : []);
      } catch (e) {
        setTipos([]);
      }
    })();
  }, []);

  const tiposOptions = useMemo(() => {
    const base = [{ label: "Todos", value: null }];
    const dyn = (tipos || []).map((t) => ({
      label: t?.descripcion ?? `Tipo ${t?.id}`,
      value: t?.id ?? null,
    }));
    return base.concat(dyn);
  }, [tipos]);

  const buscarEstado = async (empId, y, m, tId) => {
    let url =
      `${baseUrl}estadoMediciones` +
      `?empresaId=${encodeURIComponent(empId)}` +
      `&anio=${encodeURIComponent(y)}` +
      `&mes=${encodeURIComponent(m)}`;

    if (tId != null) url += `&tipoId=${encodeURIComponent(tId)}`;
    return fetchJson(url, { method: "GET" });
  };

  const TIPO_LABEL = {
    1: "AGUA",
    2: "ELECTRICIDAD",
  };

  const PRESTADOR_RUT_BY_EMPRESA = {
    1: "76.071.007-5",
    2: "76.066.122-8",
  };

  const joinUrl = (base, path) =>
    `${String(base || "").replace(/\/+$/, "")}/${String(path || "").replace(
      /^\/+/,
      "",
    )}`;

  const normalizarTipoServicio = (tipoServicio) =>
    tipoServicio == null ? null : String(tipoServicio).trim().toUpperCase();

  const keyBoleta = (remarcadorId, tipoServicio) =>
    `${String(remarcadorId ?? "")}||${normalizarTipoServicio(tipoServicio)}`;

  const rowKey = (row) =>
    `${row?.codigoDomicilio ?? "NA"}|${normalizarTipoServicio(
      row?.tipoServicio,
    )}|${row?.remarcadorId ?? "NA"}`;

  const mergeBoletasIntoItems = (baseItems, boletasRows) => {
    const map = new Map(
      (boletasRows || []).map((b) => [
        keyBoleta(b.remarcadorId, b.tipoServicio),
        b,
      ]),
    );

    return (baseItems || []).map((it) => ({
      ...it,
      _rowKey: rowKey(it),
      tipoServicio: normalizarTipoServicio(it.tipoServicio),
      boleta: map.get(keyBoleta(it.remarcadorId, it.tipoServicio)) || null,
    }));
  };

  const cargarBoletasGuardadas = async (empId, per) => {
    const urlBoletas =
      `${baseUrl}detallePeriodo/boletas` +
      `?empresaId=${encodeURIComponent(empId)}` +
      `&periodo=${encodeURIComponent(per)}`;

    const boletasData = await fetchJson(urlBoletas, { method: "GET" });
    const boletasRows = Array.isArray(boletasData?.items)
      ? boletasData.items
      : [];
    setBoletasInfo(boletasRows);
    return boletasRows;
  };

  const buscarDetalle = async (empId, per) => {
    const url =
      `${baseUrl}detallePeriodo` +
      `?empresaId=${encodeURIComponent(empId)}` +
      `&periodo=${encodeURIComponent(per)}`;

    const data = await fetchJson(url, { method: "GET" });
    const baseItems = Array.isArray(data?.items) ? data.items : [];

    let boletasRows = [];
    try {
      boletasRows = await cargarBoletasGuardadas(empId, per);
    } catch (e) {
      boletasRows = [];
      setBoletasInfo([]);
    }

    return mergeBoletasIntoItems(baseItems, boletasRows);
  };

  const fmtNumeroCL = (v, decimales = 0) => {
    const n = Number(v ?? 0);
    if (Number.isNaN(n)) return "-";

    return n.toLocaleString("es-CL", {
      minimumFractionDigits: decimales,
      maximumFractionDigits: decimales,
    });
  };

  const fmtMoneyCLP = (v) => {
    const n = Number(v ?? 0);
    if (Number.isNaN(n)) return "-";

    return `$ ${n.toLocaleString("es-CL", {
      maximumFractionDigits: 0,
    })}`;
  };

  const abrirPdfFacturador = (boleta) => {
    if (!boleta?.documentoId) {
      alert("No hay documentoId para esta boleta.");
      return;
    }

    const url = joinUrl(
      urlDocumentos,
      `descargar/boleta/pdf?idDocumento=${encodeURIComponent(
        boleta.documentoId,
      )}`,
    );

    window.open(url, "_blank", "noopener,noreferrer");
  };

  const getPrevPeriodo = (p) => {
    const m = String(p || "").match(/^(\d{4})-(\d{2})$/);
    if (!m) return null;

    let y = Number(m[1]);
    let mm = Number(m[2]);
    mm -= 1;

    if (mm === 0) {
      mm = 12;
      y -= 1;
    }

    return `${y}-${String(mm).padStart(2, "0")}`;
  };

  const getChangeRecord = (row) =>
    itemChanges[row?._rowKey || rowKey(row)] || {};

  const getWorkingValue = (row, field) => {
    const change = getChangeRecord(row);
    if (
      change?.fields &&
      Object.prototype.hasOwnProperty.call(change.fields, field)
    ) {
      return change.fields[field];
    }
    return row?.[field];
  };

  const buildCambios = (row, fields) => {
    const cambios = [];

    Object.entries(fields || {}).forEach(([campo, valorNuevo]) => {
      const valorAnterior = row?.[campo] ?? null;

      if (String(valorAnterior ?? "") !== String(valorNuevo ?? "")) {
        cambios.push({ campo, valorAnterior, valorNuevo });
      }
    });

    return cambios;
  };

  const aplicarCorreccion = () => {
    if (!correctionRow) return;

    if (!correctionDraft.motivoCorreccion?.trim()) {
      alert("Debe ingresar motivo de corrección");
      return;
    }

    const rk = correctionRow._rowKey || rowKey(correctionRow);

    const nuevosCampos = {
      lecturaMesAnterior: correctionDraft.lecturaMesAnterior,
      lecturaMesActual: correctionDraft.lecturaMesActual,
      consumoMesAnterior: correctionDraft.consumoMesAnterior,
      consumoMesActual: correctionDraft.consumoMesActual,
      saldoAnterior: correctionDraft.saldoAnterior,
      valorUnitario: correctionDraft.valorUnitario,
    };

    const cambios = buildCambios(correctionRow, nuevosCampos);

    setItemChanges((prev) => ({
      ...prev,
      [rk]: {
        esCorreccion: true,
        motivoCorreccion: correctionDraft.motivoCorreccion,
        fields: nuevosCampos,
        cambios,
      },
    }));

    setCorrectionDialogVisible(false);
  };

  const abrirCorreccion = (row) => {
    setCorrectionRow(row);

    setCorrectionDraft({
      lecturaMesAnterior: row?.lecturaMesAnterior ?? null,
      lecturaMesActual: row?.lecturaMesActual ?? null,
      consumoMesAnterior: row?.consumoMesAnterior ?? null,
      consumoMesActual: row?.consumoMesActual ?? null,
      saldoAnterior: row?.saldoAnterior ?? null,
      valorUnitario: row?.valorUnitario ?? null,
      motivoCorreccion: "",
    });

    setCorrectionDialogVisible(true);
  };

  const calcularConsumoMesActual = (row) => {
    const lma = Number(getWorkingValue(row, "lecturaMesActual") ?? 0);
    const lmp = Number(getWorkingValue(row, "lecturaMesAnterior") ?? 0);
    return Math.max(lma - lmp, 0);
  };

  const calcularTotalPagar = (row) => {
    const consumo = Number(getWorkingValue(row, "consumoMesActual") ?? 0);
    const valor = Number(getWorkingValue(row, "valorUnitario") ?? 0);
    const saldo = Number(getWorkingValue(row, "saldoAnterior") ?? 0);
    return consumo * valor + saldo;
  };

  const generarBoletas = async () => {
    if (!validar()) return;

    if (!selectedItems.length) {
      alert("Debe seleccionar al menos una boleta.");
      return;
    }

    setIsLoading(true);

    try {
      const periodo = buildPeriodo();
      const prestadorRut = PRESTADOR_RUT_BY_EMPRESA[empresaId];

      if (!prestadorRut) {
        throw new Error("No existe RUT de prestador configurado.");
      }

      const factItems = selectedItems.map((row) => {
        const change = getChangeRecord(row);

        const esCorreccion = Boolean(
          change?.esCorreccion || row?.boleta?.documentoId,
        );

        const motivoCorreccion = esCorreccion
          ? change?.motivoCorreccion || "Corrección desde revisión período"
          : null;

        return {
          remarcadorId: row.remarcadorId,
          tipoServicio: normalizarTipoServicio(row.tipoServicio),
          unidad: row.unidad || null,

          valorUnitario: getWorkingValue(row, "valorUnitario"),

          cliente: {
            rut: row.cliente?.rut || null,
            nombreRazonSocial: row.cliente?.nombreRazonSocial || "",
            telefono: row.cliente?.telefono || null,
            correo: row.cliente?.correo || null,
          },

          lecturaMesAnterior: getWorkingValue(row, "lecturaMesAnterior"),
          lecturaMesActual: getWorkingValue(row, "lecturaMesActual"),

          consumoMesAnterior: getWorkingValue(row, "consumoMesAnterior"),
          consumoMesActual:
            getWorkingValue(row, "consumoMesActual") ??
            calcularConsumoMesActual(row),

          saldoAnterior: getWorkingValue(row, "saldoAnterior") ?? 0,

          historialConsumo: [
            {
              periodo,
              consumo:
                getWorkingValue(row, "consumoMesActual") ??
                calcularConsumoMesActual(row),
            },
          ],

          esCorreccion,
          motivoCorreccion,
        };
      });

      const factPayload = {
        periodo,
        prestador: { rutEmpresa: prestadorRut },
        boletas: factItems,
      };

      const factUrl = joinUrl(urlDocumentos, "api/boletas/batch");
      const factData = await fetchJson(factUrl, {
        method: "POST",
        body: JSON.stringify(factPayload),
      });

      const resp = factData?.payload || {};
      const respItems = Array.isArray(resp?.items) ? resp.items : [];

      const guardarReq = {
        empresaId,
        periodo,
        estadoBatch: resp?.estado || null,
        mensajeBatch: resp?.mensajeGeneral || null,
        items: respItems.map((x) => {
          const original = selectedItems.find(
            (r) =>
              r.remarcadorId === x.remarcadorId &&
              normalizarTipoServicio(r.tipoServicio) ===
                normalizarTipoServicio(x.tipoServicio),
          );

          const payloadItem = factItems.find(
            (r) =>
              r.remarcadorId === x.remarcadorId &&
              normalizarTipoServicio(r.tipoServicio) ===
                normalizarTipoServicio(x.tipoServicio),
          );

          const change = getChangeRecord(original);

          return {
            remarcadorId: x.remarcadorId,
            tipoServicio: x.tipoServicio,
            documentoId: x.documentoId ?? null,
            adjuntoPdfId: x.adjuntoPdfId ?? null,
            folio: x.folio ?? null,

            snapshotId: x.snapshotId ?? null,
            version: x.version ?? null,
            vigente: x.vigente ?? null,
            correccion: x.correccion ?? null,
            snapshotReemplazadoId: x.snapshotReemplazadoId ?? null,

            status: x.status ?? null,
            errores: Array.isArray(x.errores) ? x.errores : [],

            motivoCorreccion: change?.motivoCorreccion ?? null,
            cambios: change?.cambios ?? [],
            payloadEnviado: payloadItem ?? null,
            respuestaFacturador: x ?? null,
          };
        }),
      };

      const guardarUrl = joinUrl(
        baseUrl,
        "detallePeriodo/boletas/guardar-batch",
      );

      await fetchJson(guardarUrl, {
        method: "POST",
        body: JSON.stringify(guardarReq),
      });

      alert(
        resp?.estado === "COMPLETADO"
          ? "Boletas generadas correctamente."
          : "Proceso finalizado con observaciones.",
      );

      const refreshed = await buscarDetalle(empresaId, periodo);
      setDetalleItems(refreshed);

      setSelectedItems([]);
      setItemChanges({});
    } catch (e) {
      alert(e.message || "Error generando boletas");
    } finally {
      setIsLoading(false);
    }
  };

  const revisarPeriodo = async () => {
    if (!validar()) return;

    setIsLoading(true);
    setEstadoResp(null);
    setDetalleItems([]);
    setSelectedItems([]);
    setItemChanges({});

    try {
      const periodo = buildPeriodo();

      const [estadoData, detalle] = await Promise.all([
        buscarEstado(empresaId, anio, mes, tipoId),
        buscarDetalle(empresaId, periodo),
      ]);

      setEstadoResp(estadoData);
      setDetalleItems(detalle);
      setLastQuery({ empresaId, anio, mes, tipoId, periodo });
    } catch (e) {
      alert(e.message || "Error revisando período");
    } finally {
      setIsLoading(false);
    }
  };

  const estadoBoletaBody = (row) => {
    const b = row?.boleta;

    if (!b?.documentoId) {
      return <Tag severity="warning" value="Sin boleta" />;
    }

    const version = b?.version ? ` v${b.version}` : "";
    const label = b?.correccion ? `Corregida${version}` : `Emitida${version}`;

    return <Tag severity="success" value={label} />;
  };

  const accionesBody = (row) => {
    const b = row?.boleta;

    return (
      <div className="flex gap-2">
        {b?.documentoId && (
          <>
            <Button
              icon="pi pi-file-pdf"
              className="p-button-sm p-button-text"
              tooltip="Ver PDF"
              onClick={() => abrirPdfFacturador(b)}
            />
            <Button
              icon="pi pi-pencil"
              className="p-button-sm p-button-text"
              tooltip="Corregir"
              onClick={() => abrirCorreccion(row)}
            />
          </>
        )}

        {!b?.documentoId && (
          <Button
            icon="pi pi-pencil"
            className="p-button-sm p-button-text"
            tooltip="Editar antes de enviar"
            onClick={() => abrirCorreccion(row)}
          />
        )}
      </div>
    );
  };

  const parseJsonSafe = (value, fallback = null) => {
    try {
      if (!value) return fallback;
      if (typeof value !== "string") return value;
      return JSON.parse(value);
    } catch (e) {
      return fallback;
    }
  };

  const cambiosBody = (row) => {
    const change = getChangeRecord(row);
    const cambiosGuardados = parseJsonSafe(row?.boleta?.cambiosJson, []);

    if (
      !change?.cambios?.length &&
      !change?.motivoCorreccion &&
      !cambiosGuardados?.length &&
      !row?.boleta?.motivoCorreccion
    ) {
      return <span className="text-500">Sin cambios</span>;
    }

    return (
      <div>
        {change?.esCorreccion && (
          <Tag severity="info" value="Corrección preparada" />
        )}

        {row?.boleta?.correccion && (
          <Tag
            severity="success"
            value={`Corregida v${row?.boleta?.version || ""}`}
          />
        )}

        {(change?.motivoCorreccion || row?.boleta?.motivoCorreccion) && (
          <div className="mt-1 text-sm">
            {change?.motivoCorreccion || row?.boleta?.motivoCorreccion}
          </div>
        )}

        {change?.cambios?.length > 0 && (
          <div className="mt-1 text-xs text-600">
            {change.cambios.length} cambio(s) preparado(s)
          </div>
        )}

        {cambiosGuardados?.length > 0 && (
          <div className="mt-1 text-xs text-600">
            {cambiosGuardados.length} cambio(s) guardado(s)
          </div>
        )}
      </div>
    );
  };

  const lecturaBody = (field) => (row) => {
    const value = getWorkingValue(row, field);
    return value == null ? "-" : fmtNumeroCL(value, 0);
  };

  const totalBody = (row) => fmtMoneyCLP(calcularTotalPagar(row));

  const tipoServicioFromTipoId = (tipoId) => {
    if (Number(tipoId) === 1) return "AGUA";
    if (Number(tipoId) === 2) return "ELECTRICIDAD";
    return `TIPO ${tipoId ?? "-"}`;
  };

  const getEstadoItems = () => {
    if (!estadoResp) return [];

    const leidos = Array.isArray(estadoResp.itemsLeidos)
      ? estadoResp.itemsLeidos.map((x) => ({
          ...x,
          estadoLectura: "LEIDA",
          tipoServicio: tipoServicioFromTipoId(x.tipoId),
        }))
      : [];

    const pendientes = Array.isArray(estadoResp.itemsPendientes)
      ? estadoResp.itemsPendientes.map((x) => ({
          ...x,
          estadoLectura: "PENDIENTE",
          tipoServicio: tipoServicioFromTipoId(x.tipoId),
        }))
      : [];

    return [...leidos, ...pendientes];
  };

  const calcularResumenEstado = () => ({
    total: estadoResp?.total ?? 0,
    conLectura: estadoResp?.leidos ?? 0,
    sinLectura: estadoResp?.pendientes ?? 0,
    conObservacion: 0,
  });

  const estadoLecturaBody = (row) => {
    if (row?.estadoLectura === "LEIDA") {
      return <Tag severity="success" value="Leída" />;
    }

    return <Tag severity="warning" value="Pendiente" />;
  };

  const normTxt = (v) =>
    String(v ?? "")
      .trim()
      .toUpperCase()
      .replace(/\s+/g, " ");

  const servicioOptions = [
    { label: "Todos", value: null },
    { label: "Agua", value: "AGUA" },
    { label: "Electricidad", value: "ELECTRICIDAD" },
  ];

  const estadoLecturaOptions = [
    { label: "Todos", value: null },
    { label: "Leída", value: "LEIDA" },
    { label: "Pendiente", value: "PENDIENTE" },
  ];

  const estadoBoletaOptions = [
    { label: "Todos", value: null },
    { label: "Sin boleta", value: "SIN_BOLETA" },
    { label: "Emitida", value: "EMITIDA" },
    { label: "Corregida", value: "CORREGIDA" },
  ];

  const filtrarEstadoItems = (items) => {
    return (items || []).filter((row) => {
      if (
        fEstado.remarcador &&
        !normTxt(row?.remarcadorId).includes(normTxt(fEstado.remarcador))
      ) {
        return false;
      }

      if (fEstado.qr && !normTxt(row?.qrCode).includes(normTxt(fEstado.qr))) {
        return false;
      }

      if (
        fEstado.medidorPadre &&
        !normTxt(row?.medidorPadreId).includes(normTxt(fEstado.medidorPadre))
      ) {
        return false;
      }

      if (
        fEstado.servicio &&
        normTxt(row?.tipoServicio) !== normTxt(fEstado.servicio)
      ) {
        return false;
      }

      if (
        fEstado.estadoLectura &&
        normTxt(row?.estadoLectura) !== normTxt(fEstado.estadoLectura)
      ) {
        return false;
      }

      return true;
    });
  };

  const getEstadoBoletaValue = (row) => {
    const b = row?.boleta;

    if (!b?.documentoId) return "SIN_BOLETA";
    if (b?.correccion) return "CORREGIDA";
    return "EMITIDA";
  };

  const detalleItemsFiltrados = useMemo(() => {
    return (detalleItems || []).filter((row) => {
      if (
        fDetalle.domicilio &&
        !normTxt(row?.codigoDomicilio).includes(normTxt(fDetalle.domicilio))
      ) {
        return false;
      }

      if (
        fDetalle.cliente &&
        !normTxt(row?.cliente?.nombreRazonSocial).includes(
          normTxt(fDetalle.cliente),
        )
      ) {
        return false;
      }

      if (
        fDetalle.rut &&
        !normTxt(row?.cliente?.rut).includes(normTxt(fDetalle.rut))
      ) {
        return false;
      }

      if (
        fDetalle.remarcador &&
        !normTxt(row?.remarcadorId).includes(normTxt(fDetalle.remarcador))
      ) {
        return false;
      }

      if (
        fDetalle.servicio &&
        normTxt(row?.tipoServicio) !== normTxt(fDetalle.servicio)
      ) {
        return false;
      }

      if (
        fDetalle.estadoBoleta &&
        getEstadoBoletaValue(row) !== fDetalle.estadoBoleta
      ) {
        return false;
      }

      return true;
    });
  }, [detalleItems, fDetalle]);

  const renderEstadoPeriodo = () => {
    if (!estadoResp) {
      return <p>Sin información de estado.</p>;
    }

    const resumen = calcularResumenEstado();
    const items = getEstadoItems();
    const itemsFiltrados = filtrarEstadoItems(items);

    return (
      <div>
        <div className="grid mb-3">
          <div className="col-12 md:col-3">
            <div
              className="surface-card shadow-1 border-round p-3"
              onClick={() => setActiveEstadoTab(2)}
              style={{ cursor: "pointer" }}
            >
              <div className="text-500 text-sm">Total medidores</div>
              <div className="text-2xl font-bold">{resumen.total}</div>
            </div>
          </div>

          <div className="col-12 md:col-3">
            <div
              className="surface-card shadow-1 border-round p-3"
              onClick={() => setActiveEstadoTab(0)}
              style={{ cursor: "pointer" }}
            >
              <div className="text-500 text-sm">Leídos</div>
              <div className="text-2xl font-bold">{resumen.conLectura}</div>
            </div>
          </div>

          <div className="col-12 md:col-3">
            <div
              className="surface-card shadow-1 border-round p-3"
              onClick={() => setActiveEstadoTab(1)}
              style={{ cursor: "pointer" }}
            >
              <div className="text-500 text-sm">Pendientes</div>
              <div className="text-2xl font-bold">{resumen.sinLectura}</div>
            </div>
          </div>

          <div className="col-12 md:col-3">
            <div className="surface-card shadow-1 border-round p-3">
              <div className="text-500 text-sm">Período</div>
              <div className="text-2xl font-bold">
                {estadoResp?.periodo || "-"}
              </div>
            </div>
          </div>
        </div>

        <div className="grid mb-3">
          <div className="col-12 md:col-2">
            <label>Remarcador</label>
            <InputText
              value={fEstado.remarcador}
              onChange={(e) =>
                setFEstado((p) => ({ ...p, remarcador: e.target.value }))
              }
              className="w-full"
              placeholder="Contiene..."
            />
          </div>

          <div className="col-12 md:col-2">
            <label>QR</label>
            <InputText
              value={fEstado.qr}
              onChange={(e) =>
                setFEstado((p) => ({ ...p, qr: e.target.value }))
              }
              className="w-full"
              placeholder="Contiene..."
            />
          </div>

          <div className="col-12 md:col-2">
            <label>Servicio</label>
            <Dropdown
              value={fEstado.servicio}
              options={servicioOptions}
              onChange={(e) => setFEstado((p) => ({ ...p, servicio: e.value }))}
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-2">
            <label>Estado</label>
            <Dropdown
              value={fEstado.estadoLectura}
              options={estadoLecturaOptions}
              onChange={(e) =>
                setFEstado((p) => ({ ...p, estadoLectura: e.value }))
              }
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-2">
            <label>Medidor padre</label>
            <InputText
              value={fEstado.medidorPadre}
              onChange={(e) =>
                setFEstado((p) => ({ ...p, medidorPadre: e.target.value }))
              }
              className="w-full"
              placeholder="Contiene..."
            />
          </div>

          <div className="col-12 md:col-2 flex align-items-end">
            <Button
              label="Limpiar"
              icon="pi pi-times"
              className="p-button-text w-full"
              onClick={() =>
                setFEstado({
                  remarcador: "",
                  qr: "",
                  servicio: null,
                  estadoLectura: null,
                  medidorPadre: "",
                })
              }
            />
          </div>
        </div>

        <TabView
          activeIndex={activeEstadoTab}
          onTabChange={(e) => setActiveEstadoTab(e.index)}
        >
          <TabPanel header={`Leídos (${estadoResp?.leidos ?? 0})`}>
            <DataTable
              value={itemsFiltrados.filter((x) => x.estadoLectura === "LEIDA")}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
              emptyMessage="Sin lecturas realizadas"
              responsiveLayout="scroll"
            >
              <Column field="remarcadorId" header="Remarcador" sortable />
              <Column field="tipoServicio" header="Servicio" sortable />
              <Column field="qrCode" header="QR" sortable />
              <Column field="lecturaId" header="Lectura ID" sortable />
              <Column field="lecturaFecha" header="Fecha lectura" sortable />
              <Column field="medidorPadreId" header="Medidor padre" sortable />
              <Column header="Estado" body={estadoLecturaBody} />
            </DataTable>
          </TabPanel>

          <TabPanel header={`Pendientes (${estadoResp?.pendientes ?? 0})`}>
            <DataTable
              value={itemsFiltrados.filter(
                (x) => x.estadoLectura === "PENDIENTE",
              )}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
              emptyMessage="Sin lecturas pendientes"
              responsiveLayout="scroll"
            >
              <Column field="remarcadorId" header="Remarcador" sortable />
              <Column field="tipoServicio" header="Servicio" sortable />
              <Column field="qrCode" header="QR" sortable />
              <Column field="medidorPadreId" header="Medidor padre" sortable />
              <Column header="Estado" body={estadoLecturaBody} />
            </DataTable>
          </TabPanel>

          <TabPanel header="Todos">
            <DataTable
              value={itemsFiltrados}
              paginator
              rows={10}
              rowsPerPageOptions={[10, 20, 50]}
              emptyMessage="Sin medidores"
              responsiveLayout="scroll"
            >
              <Column field="remarcadorId" header="Remarcador" sortable />
              <Column field="tipoServicio" header="Servicio" sortable />
              <Column field="qrCode" header="QR" sortable />
              <Column field="lecturaId" header="Lectura ID" sortable />
              <Column field="lecturaFecha" header="Fecha lectura" sortable />
              <Column field="medidorPadreId" header="Medidor padre" sortable />
              <Column header="Estado" body={estadoLecturaBody} />
            </DataTable>
          </TabPanel>
        </TabView>
      </div>
    );
  };

  const filtrosDetalle = (
    <div className="grid mb-3">
      <div className="col-12 md:col-2">
        <label>Domicilio</label>
        <InputText
          value={fDetalle.domicilio}
          onChange={(e) =>
            setFDetalle((p) => ({ ...p, domicilio: e.target.value }))
          }
          className="w-full"
          placeholder="Contiene..."
        />
      </div>

      <div className="col-12 md:col-2">
        <label>Cliente</label>
        <InputText
          value={fDetalle.cliente}
          onChange={(e) =>
            setFDetalle((p) => ({ ...p, cliente: e.target.value }))
          }
          className="w-full"
          placeholder="Contiene..."
        />
      </div>

      <div className="col-12 md:col-2">
        <label>RUT</label>
        <InputText
          value={fDetalle.rut}
          onChange={(e) => setFDetalle((p) => ({ ...p, rut: e.target.value }))}
          className="w-full"
          placeholder="Contiene..."
        />
      </div>

      <div className="col-12 md:col-2">
        <label>Servicio</label>
        <Dropdown
          value={fDetalle.servicio}
          options={servicioOptions}
          onChange={(e) => setFDetalle((p) => ({ ...p, servicio: e.value }))}
          className="w-full"
        />
      </div>

      <div className="col-12 md:col-2">
        <label>Remarcador</label>
        <InputText
          value={fDetalle.remarcador}
          onChange={(e) =>
            setFDetalle((p) => ({ ...p, remarcador: e.target.value }))
          }
          className="w-full"
          placeholder="Contiene..."
        />
      </div>

      <div className="col-12 md:col-2">
        <label>Estado boleta</label>
        <Dropdown
          value={fDetalle.estadoBoleta}
          options={estadoBoletaOptions}
          onChange={(e) =>
            setFDetalle((p) => ({ ...p, estadoBoleta: e.value }))
          }
          className="w-full"
        />
      </div>

      <div className="col-12 flex justify-content-end">
        <Button
          label="Limpiar filtros detalle"
          icon="pi pi-times"
          className="p-button-text"
          onClick={() =>
            setFDetalle({
              domicilio: "",
              cliente: "",
              rut: "",
              servicio: null,
              remarcador: "",
              estadoBoleta: null,
            })
          }
        />
      </div>
    </div>
  );
  const tablaDetalle = (
    <DataTable
      value={detalleItemsFiltrados}
      paginator
      rows={10}
      rowsPerPageOptions={[10, 20, 50]}
      dataKey="_rowKey"
      selection={selectedItems}
      onSelectionChange={(e) => setSelectedItems(e.value)}
      emptyMessage="Sin datos"
      responsiveLayout="scroll"
    >
      <Column selectionMode="multiple" headerStyle={{ width: "3rem" }} />
      <Column field="codigoDomicilio" header="Domicilio" sortable />
      <Column
        header="Cliente"
        body={(row) => row?.cliente?.nombreRazonSocial || "-"}
        sortable
      />
      <Column header="RUT" body={(row) => row?.cliente?.rut || "-"} sortable />
      <Column field="tipoServicio" header="Servicio" sortable />
      <Column field="remarcadorId" header="Remarcador" sortable />
      <Column
        header="Estado boleta"
        body={estadoBoletaBody}
        style={{ minWidth: "10rem" }}
      />
      <Column header="Lec. anterior" body={lecturaBody("lecturaMesAnterior")} />
      <Column header="Lec. actual" body={lecturaBody("lecturaMesActual")} />
      <Column header="Consumo" body={lecturaBody("consumoMesActual")} />
      <Column
        header="Valor unit."
        body={(row) => fmtMoneyCLP(getWorkingValue(row, "valorUnitario"))}
      />
      <Column
        header="Saldo anterior"
        body={(row) => fmtMoneyCLP(getWorkingValue(row, "saldoAnterior"))}
      />
      <Column header="Total" body={totalBody} />
      <Column
        header="Cambios"
        body={cambiosBody}
        style={{ minWidth: "14rem" }}
      />
      <Column
        header="Acciones"
        body={accionesBody}
        style={{ minWidth: "8rem" }}
      />
    </DataTable>
  );

  const footerCorreccion = (
    <div className="flex justify-content-end gap-2">
      <Button
        label="Cancelar"
        icon="pi pi-times"
        className="p-button-text"
        onClick={() => setCorrectionDialogVisible(false)}
      />
      <Button label="Aplicar" icon="pi pi-check" onClick={aplicarCorreccion} />
    </div>
  );

  return (
    <div className="p-4">
      <div className="card">
        <h2>Revisión período</h2>

        <div className="grid">
          <div className="col-12 md:col-3">
            <label>Empresa</label>
            <Dropdown
              value={empresaId}
              options={empresasOptions}
              onChange={(e) => setEmpresaId(e.value)}
              placeholder="Seleccione empresa"
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-2">
            <label>Año</label>
            <Dropdown
              value={anio}
              options={aniosOptions}
              onChange={(e) => setAnio(e.value)}
              placeholder="Año"
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-2">
            <label>Mes</label>
            <Dropdown
              value={mes}
              options={mesesOptions}
              onChange={(e) => setMes(e.value)}
              placeholder="Mes"
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-3">
            <label>Tipo</label>
            <Dropdown
              value={tipoId}
              options={tiposOptions}
              onChange={(e) => setTipoId(e.value)}
              placeholder="Tipo"
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-2 flex align-items-end">
            <Button
              label="Revisar"
              icon="pi pi-search"
              onClick={revisarPeriodo}
              disabled={isLoading}
              className="w-full"
            />
          </div>
        </div>

        <div className="mt-3 flex justify-content-between align-items-center">
          <div>
            <strong>Período:</strong> {periodoLabel}
            {selectedItems.length > 0 && (
              <span className="ml-3">
                <strong>Seleccionadas:</strong> {selectedItems.length}
              </span>
            )}
          </div>

          {activeMainTab === 1 && (
            <Button
              label="Enviar seleccionadas"
              icon="pi pi-send"
              onClick={generarBoletas}
              disabled={
                isLoading || !detalleItems.length || selectedItems.length === 0
              }
            />
          )}
        </div>

        {isLoading && (
          <div className="flex justify-content-center mt-4">
            <ProgressSpinner />
          </div>
        )}

        {!isLoading && (
          <TabView
            activeIndex={activeMainTab}
            onTabChange={(e) => setActiveMainTab(e.index)}
            className="mt-4"
          >
            <TabPanel header="Estado período">{renderEstadoPeriodo()}</TabPanel>

            <TabPanel header="Detalle Periodo">
              {filtrosDetalle}
              {tablaDetalle}
            </TabPanel>

            <TabPanel header="Boletas guardadas">
              <DataTable
                value={boletasInfo}
                paginator
                rows={10}
                rowsPerPageOptions={[10, 20, 50, 100]}
                emptyMessage="Sin boletas guardadas"
                responsiveLayout="scroll"
              >
                <Column field="remarcadorId" header="Remarcador" sortable />
                <Column field="tipoServicio" header="Servicio" sortable />
                <Column field="documentoId" header="Documento" sortable />
                <Column field="folio" header="Folio" sortable />
                <Column field="version" header="Versión" sortable />
                <Column field="vigente" header="Vigente" sortable />
                <Column field="correccion" header="Corrección" sortable />
                <Column
                  header="PDF"
                  body={(row) =>
                    row?.documentoId ? (
                      <Button
                        icon="pi pi-file-pdf"
                        className="p-button-sm p-button-text"
                        onClick={() => abrirPdfFacturador(row)}
                      />
                    ) : (
                      "-"
                    )
                  }
                />
              </DataTable>
            </TabPanel>
          </TabView>
        )}
      </div>

      <Dialog
        header={
          correctionRow?.boleta?.documentoId
            ? "Corregir boleta"
            : "Editar boleta antes de enviar"
        }
        visible={correctionDialogVisible}
        style={{ width: "50rem", maxWidth: "95vw" }}
        modal
        footer={footerCorreccion}
        onHide={() => setCorrectionDialogVisible(false)}
      >
        <div className="grid">
          <div className="col-12">
            <p className="m-0">
              <strong>Servicio:</strong>{" "}
              {normalizarTipoServicio(correctionRow?.tipoServicio)}{" "}
              <strong className="ml-3">Remarcador:</strong>{" "}
              {correctionRow?.remarcadorId ?? "-"}
            </p>
          </div>

          <div className="col-12 md:col-6">
            <label>Lectura mes anterior</label>
            <InputNumber
              value={correctionDraft.lecturaMesAnterior}
              onValueChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  lecturaMesAnterior: e.value,
                }))
              }
              locale="es-CL"
              minFractionDigits={0}
              maxFractionDigits={0}
              useGrouping={true}
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-6">
            <label>Lectura mes actual</label>
            <InputNumber
              value={correctionDraft.lecturaMesActual}
              onValueChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  lecturaMesActual: e.value,
                }))
              }
              locale="es-CL"
              minFractionDigits={0}
              maxFractionDigits={0}
              useGrouping={true}
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-6">
            <label>Consumo mes anterior</label>
            <InputNumber
              value={correctionDraft.consumoMesAnterior}
              onValueChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  consumoMesAnterior: e.value,
                }))
              }
              locale="es-CL"
              minFractionDigits={0}
              maxFractionDigits={0}
              useGrouping={true}
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-6">
            <label>Consumo mes actual</label>
            <InputNumber
              value={correctionDraft.consumoMesActual}
              onValueChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  consumoMesActual: e.value,
                }))
              }
              locale="es-CL"
              minFractionDigits={0}
              maxFractionDigits={0}
              useGrouping={true}
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-6">
            <label>Saldo anterior</label>
            <InputNumber
              value={correctionDraft.saldoAnterior}
              onValueChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  saldoAnterior: e.value,
                }))
              }
              mode="currency"
              currency="CLP"
              currencyDisplay="symbol"
              locale="es-CL"
              minFractionDigits={0}
              maxFractionDigits={0}
              useGrouping={true}
              className="w-full"
            />
          </div>

          <div className="col-12 md:col-6">
            <label>Valor unitario</label>
            <InputNumber
              value={correctionDraft.valorUnitario}
              onValueChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  valorUnitario: e.value,
                }))
              }
              mode="currency"
              currency="CLP"
              currencyDisplay="symbol"
              locale="es-CL"
              minFractionDigits={0}
              maxFractionDigits={0}
              useGrouping={true}
              className="w-full"
            />
          </div>

          <div className="col-12">
            <label>Motivo</label>
            <InputTextarea
              value={correctionDraft.motivoCorreccion}
              onChange={(e) =>
                setCorrectionDraft((p) => ({
                  ...p,
                  motivoCorreccion: e.target.value,
                }))
              }
              rows={4}
              className="w-full"
              placeholder="Indique motivo de la corrección o edición"
            />
          </div>
        </div>
      </Dialog>
    </div>
  );
};

export default RevisionPeriodo;
